import { render, staticRenderFns } from "./monigerenzhengxinbaogao.vue?vue&type=template&id=15df19bc&scoped=true"
import script from "./monigerenzhengxinbaogao.vue?vue&type=script&lang=js"
export * from "./monigerenzhengxinbaogao.vue?vue&type=script&lang=js"
import style0 from "./monigerenzhengxinbaogao.vue?vue&type=style&index=0&id=15df19bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df19bc",
  null
  
)

export default component.exports